import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Container } from "reactstrap";
//URL
import configData from "../../../config.json";
import { authenticationService } from 'services/authentication.service';
//DATA TABLE
import DataTable, { TableColumn } from 'react-data-table-component';
import { handle_error } from 'components/DirectivoUnidad/Vacaciones/helper_function';
import Cargando from 'components/Varios/Cargando';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authHeaderWithUserData } from 'helpers/auth-header';
import { downloadExcelReportNoYear } from 'helpers/downloadExcelReport';
import { alertService } from 'components/Varios/alert_service';
import IconCloseModal from 'components/Varios/Modals/IconCloseModal';



export type DatosLocalidadDetalle = {
    idlocalidadunidad: number,
    nombrelocalidadunidad: string,
}

type Props_ModalDetalleCronogramaUnidad = {
    show: boolean
    toogle: () => void
    onClose: () => void
    datosLocalidad: DatosLocalidadDetalle
}
type PlanificacionesPersonasCronogramasDTO = {
    nombres: string,
    numeroidentificacion: string,
    fechainicio: string,
    fechafin: string,
    diasplanificados: number
}

const ModalDetalleCronogramaUnidad: React.FC<Props_ModalDetalleCronogramaUnidad> = (props: Props_ModalDetalleCronogramaUnidad) => {

    const [progressPending, setprogressPending] = useState<boolean>(true)
    const [rowsTabla, setrowsTabla] = useState<Array<PlanificacionesPersonasCronogramasDTO>>([])
    const [tablaPlanificacionesPersonas, settablaPlanificacionesPersonas] = useState<JSX.Element>();
    const [contenidoError, setcontenidoError] = useState<JSX.Element>()
    const [loadingButtonLocalidad, setloadingButtonLocalidad] = useState<boolean>(false)
    const [loadingModal, setloadingModal] = useState<boolean>(true);
    const [descargandoReporteSeguimiento, setdescargandoReporteSeguimiento] = useState<boolean>(false)

    function CerrarModal() {
        settablaPlanificacionesPersonas(undefined)
        setcontenidoError(undefined)
        setrowsTabla([])
        props.toogle();
    }
    const generar_tabla_detalle_cronograma = (informacion: Array<PlanificacionesPersonasCronogramasDTO>) => {
        const columns: TableColumn<PlanificacionesPersonasCronogramasDTO>[] = [
            {
                name: "CÉDULA",
                selector: (row) => row.numeroidentificacion,
                minWidth: "168px",
                maxWidth: "168px",

                // width: "fit-content",
                center: true,
            },
            {
                name: "PERSONAL",
                selector: (row) => row.nombres,
                minWidth: "300px",
                width: "300px",
                style: {
                    "text-align": "left",
                }



            },
            {
                name: "FECHA DESDE",
                selector: (row) => row.fechainicio,
                center: true,
                minWidth: "168px",
                maxWidth: "168px",


            },
            {
                name: "FECHA HASTA",
                selector: (row) => row.fechafin,
                center: true,
                minWidth: "168px",
                maxWidth: "168px",



            },
            {
                name: "DÍAS PLANIFICADOS",
                selector: (row) => row.diasplanificados,
                center: true,
                minWidth: "150px",
                maxWidth: "150px",



            }
        ]

        const paginationComponentOptions = {
            rowsPerPageText: 'Filas por página',
            rangeSeparatorText: 'de',
            selectAllRowsItem: true,
            selectAllRowsItemText: 'Todos',
        };
        const paginationrows = [5, 10, 15, 20, 25]

        const customStyles_tabla = {
            table: {
                style: {
                    border: "solid 1px"
                },
            },
            headRow: {
                style: {
                    backgroundColor: "#243165",
                    color: "white",
                    fontSize: '1.2em',
                    "text-align": "center !important"

                },
                denseStyle: {
                    minHeight: '32px',
                },
            },
            rows: {
                style: {
                    minHeight: '50px', // override the row height
                    fontSize: '1em',

                },
            },
        }


        if (informacion.length > 0) {
            return (
                <DataTable
                    columns={columns}
                    data={informacion}
                    responsive={true}
                    pagination paginationComponentOptions={paginationComponentOptions}
                    paginationRowsPerPageOptions={paginationrows}
                    striped
                    customStyles={customStyles_tabla}

                />
            )
        }
        else{
            return(
                <div className='text-center'>No hay planificaciones enviadas a Talento Humano del personal de la Unidad</div>
            )
        }


    }

    const descargarReporteUnidad = async (datos: DatosLocalidadDetalle) => {
        setloadingButtonLocalidad(true);
        var currentUser = authenticationService.currentUserValue;

        await fetch(configData.SERVER_URL + `PlanificacionVacaciones/Administrador/Reporte/DetalleLocalidad/${datos.idlocalidadunidad}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `KEYESPOL ${currentUser?.token}`
            },
        })
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = "reporte_localidad_" + datos.nombrelocalidadunidad  //nombrearchivo
                    a.click();
                });
            })
            .catch((error) => {
                var error_any: any = error;
                var status_code: number = handle_error(error_any);
                switch (status_code) {
                    case 0:
                        setcontenidoError(<div>No se ha podido establecer contacto con el servidor</div>);
                        break;
                    case 500:
                        setcontenidoError(<div>Ha ocurrido un error inesperado</div>);

                        break;
                    default:
                        setcontenidoError(<div>Ha ocurrido un error</div>);
                        break;
                }

            });
        setloadingButtonLocalidad(false);
    }

    async function descargarReporteSeguimientoPlanificaciones(datos: DatosLocalidadDetalle) {
        try {
            setdescargandoReporteSeguimiento(true)
            const URL = `PlanificacionVacaciones/Administrador/Reporte/DetallePlanificacionesLocalidad/${datos.idlocalidadunidad}`
            await downloadExcelReportNoYear(URL, "Reporte Seguimiento Planificaciones Unidad" + datos.nombrelocalidadunidad + ".xlsx")
            setdescargandoReporteSeguimiento(false)
        } catch (error) {
            alertService.error("Ha ocurrido un inconveniente al intentar descargar el reporte")
        }
    }



    useEffect(() => {

        const Obtener_Informacion_Detalle_Planificaciones = async () => {
            setloadingModal(true);

            var currentUser = authenticationService.currentUserValue;
            try {
                const respuesta = await axios.get(configData.SERVER_URL + `PlanificacionVacaciones/Administrador/CronogramaUnidades/Detalles/${props.datosLocalidad.idlocalidadunidad}`,
                    {
                        headers: {
                            Authorization: `KEYESPOL ${currentUser?.token}`
                        }


                    });

                var respuesta_calendario: Array<PlanificacionesPersonasCronogramasDTO> = respuesta.data;

                setrowsTabla(respuesta_calendario);
            } catch (error) {
                var status_number: number = handle_error(error)
                switch (status_number) {
                    case 0:
                        setcontenidoError(<div>No se ha podido establecer conexión con el servidor</div>)
                        break;
                    case 500:
                        setcontenidoError(<div>Ha ocurrido un inconveniente intente más tarde</div>)

                    default:
                        setcontenidoError(<div>Ha ocurrido un error</div>)
                        break;
                }
            }
            setloadingModal(false);

        }

        const { idlocalidadunidad, nombrelocalidadunidad } = props.datosLocalidad;
        if (idlocalidadunidad !== -1 && nombrelocalidadunidad !== "") {
            
             Obtener_Informacion_Detalle_Planificaciones();
        }
    }, [props.datosLocalidad.idlocalidadunidad, props.datosLocalidad.nombrelocalidadunidad])

    useEffect(() => {
        
            setprogressPending(true);
            settablaPlanificacionesPersonas(generar_tabla_detalle_cronograma(rowsTabla));
            setprogressPending(false);
        

    }, [rowsTabla])


    const botonDescargarReporteSeguimiento = useMemo(() => {
        if (!descargandoReporteSeguimiento) {
            return (
                <button
                    disabled={descargandoReporteSeguimiento}
                    className="btnDescargarCronogramaPlanVac"
                    onClick={() => descargarReporteSeguimientoPlanificaciones(props.datosLocalidad)}
                >
                    Descargar Reporte Seguimiento Planificaciones Unidad
                </button>
            )
        }
        else {
            return (
                <button disabled={descargandoReporteSeguimiento} className="btnDescargarCronogramaPlanVac">Preparando Reporte...</button>
            )
        }
    }, [descargandoReporteSeguimiento, props.datosLocalidad])


    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"xl "}
            fullscreen={"xl"}
            centered={true}
            onClosed={props.onClose}
        >
            <ModalHeader close={ <IconCloseModal handleClickIcon={() => CerrarModal()} /> }>
                Detalle Unidades
            </ModalHeader>

            <ModalBody>

                <Container fluid={true}>

                    <Row className="mb-3">
                        <Col xl={12} className="nombreLocalidadModal">
                            {props.datosLocalidad.nombrelocalidadunidad}

                        </Col>
                    </Row>
                    <Row className="justify-content-end mb-2 ">
                        <Col xl={3} md={6} sm={12} className="text-right">
                            {botonDescargarReporteSeguimiento}
                        </Col>
                        {
                            rowsTabla.length !== 0 &&

                            <Col xl={3} md={6} sm={12} className="mb-2 mb-sm-2 mb-md-0 text-center text-md-0">
                                {
                                    !loadingButtonLocalidad &&
                                    <button disabled={loadingButtonLocalidad}
                                        className="btnDescargarCronogramaPlanVac"
                                        onClick={() => descargarReporteUnidad(props.datosLocalidad)}>Descargar Reporte General Unidad
                                    </button>
                                }
                                {
                                    loadingButtonLocalidad &&
                                    <button disabled={loadingButtonLocalidad} className="btnDescargarCronogramaPlanVac">Preparando Reporte...</button>
                                }
                            </Col>

                        }
                    </Row>

                    {loadingModal && <Cargando />}
                    {!loadingModal &&
                        // <React.Fragment>

                        // </React.Fragment>

                        <Row className="justify-content-center mb-3">
                            <Col xl={11} lg={10} sm={12} md={12} >
                                {contenidoError}
                                {loadingModal && <Cargando/>}
                                {!loadingModal && tablaPlanificacionesPersonas}
                            </Col>
                        </Row>
                    }


                </Container>
            </ModalBody>
        </Modal>
    )
}
export default ModalDetalleCronogramaUnidad
